import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { Totes_FlowService } from './Totes.flow.index';
import { ProgrammableLogicController_FlowService } from './ProgrammableLogicController.flow.index';

import { app_test_tcp_connectionService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.Totes = this.injector.get(Totes_FlowService);
    this.ProgrammableLogicController = this.injector.get(ProgrammableLogicController_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public Totes: Totes_FlowService;
    public ProgrammableLogicController: ProgrammableLogicController_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _test_tcp_connection: app_test_tcp_connectionService;
  public async test_tcp_connection($inParams: {  }): Promise< { output?: string }> {
    if(!this._test_tcp_connection) { 
      this._test_tcp_connection = this.injector.get(app_test_tcp_connectionService);
    }
    return this._test_tcp_connection.run($inParams);
  }
   
   

   
}
